export default function truncateToDecimal(value, decimalPlaces = 1) {
  const multiplier = 10 ** decimalPlaces;
  return Math.floor(value * multiplier) / multiplier;
}
